/**
 * Accordion Module
 * Manages accordion behavior - ensures only one item is open at a time
 */

const accordion = {
  /**
   * Initialize accordion
   * @param {string} selector - CSS selector for the accordion container
   * @param {boolean} isImageAccordion - If true, controls image display in .image-stack or .image-panel
   */
  init(selector, isImageAccordion = false) {
    const accordions = document.querySelectorAll(selector);
    
    if (!accordions.length) {
      return;
    }

    accordions.forEach(accordionElement => {
      this.setupAccordion(accordionElement, isImageAccordion);
    });
  },

  /**
   * Set up a single accordion
   */
  setupAccordion(accordionElement, isImageAccordion) {
    const checkboxes = accordionElement.querySelectorAll('input[type="checkbox"]');
    
    if (!checkboxes.length) {
      return;
    }

    // Find the image container if this is an image accordion
    let imageContainer = null;
    if (isImageAccordion) {
      const parentSection = accordionElement.closest('*:has(.image-stack), *:has(.image-panel)');
      if (parentSection) {
        imageContainer = parentSection.querySelector('.image-stack, .image-panel');
      }
    }

    // Add change event listener to each checkbox
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', (e) => {
        if (e.target.checked) {
          // Uncheck all other checkboxes in this accordion
          checkboxes.forEach(otherCheckbox => {
            if (otherCheckbox !== e.target) {
              otherCheckbox.checked = false;
            }
          });

          // Handle image display if this is an image accordion
          if (isImageAccordion && imageContainer) {
            this.updateImageDisplay(imageContainer, e.target.id);
          }
        }
      });
    });

    // Set initial image display for image accordions
    if (isImageAccordion && imageContainer) {
      const firstChecked = accordionElement.querySelector('input[type="checkbox"]:checked');
      if (firstChecked) {
        this.updateImageDisplay(imageContainer, firstChecked.id);
      } else if (checkboxes.length > 0) {
        // Default to first checkbox if none checked
        this.updateImageDisplay(imageContainer, checkboxes[0].id);
      }
    }
  },

  /**
   * Update which image is displayed based on the active accordion item
   */
  updateImageDisplay(imageContainer, checkboxId) {
    const figures = imageContainer.querySelectorAll('figure[data-image]');
    
    if (!figures.length) {
      return;
    }

    // Hide all figures
    figures.forEach(figure => {
      figure.style.display = 'none';
    });

    // Show the figure corresponding to the active checkbox
    // Extract the number or identifier from the checkbox ID (e.g., "cap1" -> "cap1")
    const targetFigure = imageContainer.querySelector(`figure[data-image="${checkboxId}"]`);
    
    if (targetFigure) {
      targetFigure.style.display = 'block';
    }
  }
};

export default accordion;
